
import Swal from "sweetalert2";
import {getToken, isLogged, setLogged} from '../utils/auth';
import router from "../router/index";
import Cookies from "js-cookie";
import store from '@/store'; 
const axios = require('axios');
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  
});


// Request interceptors
service.interceptors.request.use(
  config => {
    store.commit('globalData/SET_LOADING', true);
    const token = isLogged();
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + getToken();
      config.headers['Content-Type'] = 'application/json';
      config.headers['Accept'] = 'application/json';
      config.headers['Access-Control-Allow-Origin'] = '*';
      config.headers['language']= Cookies.get("lang") ||'ar'
    }
  
    return config;
  },
  error => {
    // Do something with request error
    let message = error.message;
    
    if (error.response.data && error.response.data.errors) {
      message = error.response.data.errors;
    } else if (error.response.data && error.response.data.error) {
      message = error.response.data.error;
    }
    if (error.response.status !== 401 && error.response.status !== 404) {
      
    }
    return Promise.reject(error);
  }
);

// response pre-processing
service.interceptors.response.use(
  
  response => {
    store.commit('globalData/SET_LOADING', false);
    return response.data;
  },
  error => {
    store.commit('globalData/SET_LOADING', false);
    let message;
    if (error.response.data && error.response.data.errors) {
      message = error.response.data.errors;
    } else if (error.response.data && error.response.data.errors == null && error.response.data.message) {
      message = error.response.data.message;
      
      }
      // If Request Not [---- 404 OR 401 ---]
    if (error.response.data.status !== 401 && error.response.data.status !== 404) {
      
      if (message) {
        Swal.fire({
          icon: 'error',
          text: message,
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        })
      } else {
        Swal.fire({
          icon: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        })
      }
    }
    // Not Found Page Or Api Request
    if ((error.response.status === 404 && !message) || (error.response.status === 404 && !message.name)) {
      router.push( {name: "NotFound"});
    }
    // NotAuthenticated
    if (error.response.status === 401) {
      setLogged('2');
      Swal.fire({
        icon: 'error',
        text: message,
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      })
      router.push( {name: "Login"});
    }
    return Promise.reject(error);
  }
);


export default service;